import { render, staticRenderFns } from "./FuncBtn.vue?vue&type=template&id=5c1c12db&scoped=true"
import script from "./FuncBtn.vue?vue&type=script&lang=js"
export * from "./FuncBtn.vue?vue&type=script&lang=js"
import style0 from "./FuncBtn.vue?vue&type=style&index=0&id=5c1c12db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1c12db",
  null
  
)

export default component.exports